import React, { PureComponent } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Table, Button, Tooltip, OverlayTrigger } from 'react-bootstrap'
import IDocCarPagination from '../../commons/iDocCarPagination'
import CustomFieldModalPage from '../../../containers/masters/CustomField/CustomFieldModalPage'
import InputSelect from '../../commons/form/InputSelect'
import { handleKeyDown } from '../../../util/utils'
import MapSectionsMasters from '../../../util/map-sections-masters'

class CustomFieldMaster extends PureComponent {
  constructor () {
    super()
    this.state = {
      filter: {
        dossierSubtypeId: null
      }
    }
  }

  componentDidMount () {
    this.props.actions.fetchCustomFieldList()
    this.props.actions.fetchDossierSubTypes()
    this.props.actions.fetchCustomFieldTypesCombo()
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchCustomFieldList({ ...this.state.filter, ...this.props.filter, orderBy: `-${field}` })
        break
      default:
        this.props.actions.fetchCustomFieldList({ ...this.state.filter, ...this.props.filter, orderBy: `+${field}` })
        break
    }
  }

  handleDossierSubtypeChange (dossierSubtypeId) {
    if (this.state.filter.dossierSubtypeId !== dossierSubtypeId) {
      this.setState({ filter: { ...this.state.filter, dossierSubtypeId: dossierSubtypeId, page: 1 } })
    }
  }

  searchCustomFieldList () {
    this.props.actions.fetchCustomFieldList({ ...this.props.filter, ...this.state.filter, page: 1 })
  }

  resetFilters () {
    this.setState({
      filter: {
        dossierSubtypeId: null
      }
    }, () => { this.props.actions.fetchCustomFieldList({ ...this.props.filter, ...this.state.filter, page: 1 }) })
  }

  render () {
    const {
      t, customFieldList, pagesCount, customFieldsCount, filter,
      combos: { dossierSubtypes, customFieldTypes },
      filter: { page },
      actions: { openCustomFieldModal, fetchCustomFieldList, deleteCustomField, recoverCustomField }
    } = this.props

    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'customFieldsMasterPage' })
    const tKey = 'MASTERS.CUSTOM_FIELDS.'
    const editTooltip = (<Tooltip id="editTooltip">{t('MASTERS.EDIT')}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t('MASTERS.DELETE')}</Tooltip>)
    const recoverTooltip = (<Tooltip id="recoverTooltip">{t('MASTERS.RECOVER')}</Tooltip>)
    const hasFilters = (this.state.filter.dossierSubtypeId)
    return (
      <div id="CustomFieldMaster" className="inner-results-panel">
        <div className="section-results-header">
          <div className="section-header-title">
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
            <h4>{t(`${secMapMasters.title}`)}</h4>
            {this.state.filter?.dossierSubtypeId && (
              <Button
                className="_Btn new"
                onClick={() => openCustomFieldModal(null, this.state.filter?.dossierSubtypeId)}>
                <i className='iDocIcon-add-plus'></i> {t('MASTERS.ADD')} {t(`${secMapMasters.title}`)}
              </Button>
            )}
          </div>
          <div className='filters'>
            <div className="search-form">
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="filters.dossierSubtypeId"
                controlLabel={t(`${tKey}DOSSIER_SUBTYPE`)}
                placeholder={t(`${tKey}DOSSIER_SUBTYPE`)}
                valueKey="id"
                labelKey="value"
                options={dossierSubtypes}
                onInputChange={(value) => this.handleDossierSubtypeChange(value)}
              />
              <div className="search-form-actions flexInLine al-R">
                <p></p>
                <Button
                  className={'_Btn accept'}
                  onClick={() => this.searchCustomFieldList()}
                  onKeyDown={(e) => handleKeyDown(e)}>
                  <i className="iDocIcon-search"/>
                  {t(`${tKey}SEARCH`)}
                </Button>
                <Button
                  className={'_Btn accept stk ' + (hasFilters ? ' ' : 'disabled')}
                  onClick={() => {
                    this.props.initialize({})
                    this.resetFilters()
                  }}
                >
                  <i className="ico-cancel" />
                  {t('MASTERS.RESET_BUTTON')}
                </Button>
              </div>
            </div>
          </div>

        </div>
        <div className='section-results-body'>
          <div className={'searchResoultsContainer' + (this.state.maxiTable ? ' maxiTable' : '')}>
            <div className="table-wrapper" key="table-wrapper">

              {customFieldList?.length > 0 &&
               <>
                 {/* table */}
                 <Table className="editable-table" hover responsive>
                   <thead>
                     <tr>
                       <th onClick={() => { this.changeOrder('code') }}>
                         {t(`${tKey}FIELD_CODE`)}
                         <i className={this.getSortIcon('code')} />
                       </th>
                       <th onClick={() => { this.changeOrder('viewComponentCode') }}>
                         {t(`${tKey}COMPONENT`)}
                         <i className={this.getSortIcon('viewComponentCode')} />
                       </th>
                       <th onClick={() => { this.changeOrder('name') }}>
                         {t(`${tKey}FIELD_NAME`)}
                         <i className={this.getSortIcon('name')} />
                       </th>
                       <th onClick={() => { this.changeOrder('CustomFieldTypeName') }}>
                         {t(`${tKey}FIELD_TYPE`)}
                         <i className={this.getSortIcon('CustomFieldTypeName')} />
                       </th>
                       <th className='accesoriesActions actions'>{t(`${tKey}ACTIONS`)}</th>
                     </tr>
                   </thead>
                   <tbody>
                     {customFieldList.map((customField, idx) => {
                       return (
                         <tr key={idx} className={customField.isDeleted ? 'is-deleted' : ''}>
                           <td>{customField.code}</td>
                           <td>{customField.viewComponent?.code}</td>
                           <td>{customField.customFieldLocales && customField.customFieldLocales.length > 0
                             ? customField.customFieldLocales.find(lang => (lang.languageId ?? '') === this.props.languageSelected)?.name
                             : ''}</td>
                           <td>{customFieldTypes?.find(x => x.id === customField.customFieldTypeId)?.value ?? null}</td>
                           <td className='actions'>
                             <div>
                               <OverlayTrigger placement="left" overlay={editTooltip}>
                                 <a className='_Btn accept stk o-icn ' onClick={() => openCustomFieldModal(customField, customField.dossierSubTypeId)}>
                                   <i className="iDocIcon-edit" />
                                 </a>
                               </OverlayTrigger>
                               { customField.isDeleted ? (
                                 <OverlayTrigger placement="left" overlay={recoverTooltip}>
                                   <a className='_Btn accent stk o-icn ' onClick={() => recoverCustomField(customField.customFieldId)}>
                                     <i className='iDocIcon-update'/>
                                   </a>
                                 </OverlayTrigger>
                               ) : (
                                 <OverlayTrigger placement="left" overlay={deleteTooltip}>
                                   <a className='_Btn cancel stk o-icn ' onClick={() => deleteCustomField(customField.customFieldId)}>
                                     <i className="iDocIcon-delete-forever" />
                                   </a>
                                 </OverlayTrigger>
                               )}
                             </div>
                           </td>
                         </tr>
                       )
                     })}
                   </tbody>
                 </Table>
               </>
              }
              {(customFieldList === undefined || customFieldList?.length === 0) &&
                <p className="no_results" >{t(`${tKey}RESULTS_NOT_FOUND`)}</p>
              }
              <div className="search-footer">
                <nav key={1} className="text-center">
                  <IDocCarPagination
                    id="btn_pag_sales"
                    page={page}
                    pagesCount={pagesCount}
                    totalRows={customFieldsCount}
                    onSelectAction={(value) => fetchCustomFieldList({ ...filter, ...this.state.filter, page: value })}
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
        <CustomFieldModalPage/>
      </div>

    )
  }
}

export default reduxForm({
  form: 'customFildList'
})(CustomFieldMaster)
